import { render, staticRenderFns } from "./TireHeader.vue?vue&type=template&id=6072c84c"
import script from "./TireHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TireHeader.vue?vue&type=style&index=0&id=6072c84c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports